import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { lazyLogSigsDatapoint, logUsage } from 'owa-analytics';
import { AttachmentFullViewState, AttachmentMenuAction } from 'owa-attachment-full-data';
import isAttachmentDownloadable from 'owa-attachment-full-data/lib/utils/isAttachmentDownloadable';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';
import { downloadAttachment, PreviewContext } from 'owa-attachment-select-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { downloadText } from 'owa-locstrings/lib/strings/downloadtext.locstring.json';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';
import getSenderFromItemId from '../../utils/getSenderFromItemId';
import isMenuActionSupported from '../isMenuActionSupported';

export default function downloadContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType?: string,
    targetWindow?: Window,
    isConsumer?: boolean,
    attachmentOriginalUrl?: string,
    permissionLevel?: AttachmentPermissionLevel,
    previewContext?: PreviewContext,
    parentItemId?: ItemId,
    replaceAttachmentHandler?: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void,
    AttachLongPathName?: string,
    container?: HTMLElement
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);

    if (
        !isMenuActionSupported(AttachmentMenuAction.Download, attachment) ||
        !attachmentModel ||
        !isAttachmentDownloadable(attachment)
    ) {
        return null;
    }

    const fileType = getAttachmentFileType(attachmentModel);

    return {
        name: loc(downloadText),
        key: 'download',
        onClick: () => {
            logUsage(
                'AttachmentDownload',
                {
                    entryPoint: 'ContextMenu',
                    isCloudy: attachment.isCloudy,
                    isCompose: !attachment.isReadOnly,
                },
                {
                    cosmosOnlyData: JSON.stringify({
                        size: attachmentModel.model.Size,
                        fileType: fileType,
                        attachmentId: attachmentModel.model.AttachmentId?.Id,
                    }),
                }
            );
            downloadAttachment(attachment.attachmentId, attachment.isCloudy, container);
            if (isFeatureEnabled('doc-attachment-sigs')) {
                const itemId = parentItemId?.Id;
                lazyLogSigsDatapoint.importAndExecute('SavedAttachment', {
                    itemId,
                    customProperties: {
                        FileId: attachment.attachmentId.Id,
                        FileType: fileType,
                        Destination: 'Local',
                        Sender: getSenderFromItemId(itemId),
                    },
                });
            }
        },
    };
}
